import { defineComponent, PropType } from "vue";
import { Image } from "@/interfaces/Image";

export default defineComponent({
  props: {
    images: { type: Array as PropType<Image[]>, required: false },
  },
  setup() {
    const showImages = window.innerWidth >= 768;

    return { showImages };
  },
});
